'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIterable;

var _lodash = require('lodash.isstring');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * @param checkForIterator The value that should be checked
 * @returns {boolean} Returns `true` when the value is iterable, otherwise false.
 *
 * @example
 * isIterable('My value'); // Returns:  true
 *
 * @example
 * isIterable([1, 2, 3]); // Returns: true
 *
 * @example
 * isIterable({}); // Returns: false
 *
 * @example
 * let iterableObject = {
 *     [Symbol.iterator]: () => {}
 * };
 * isIterable(iterableObject); // Returns: true
 */
function isIterable(checkForIterator) {
  return Boolean((checkForIterator || (0, _lodash2.default)(checkForIterator)) && checkForIterator[Symbol.iterator]);
}
//# sourceMappingURL=isIterable.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-utilizr/lib/isIterable.js
 ** module id = 318
 ** module chunks = 0
 **/